import React, { useState } from "react";
import "./Settings.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Nav, Tab } from "react-bootstrap";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Profile from "./profile/Profile";
import Security_Settings from "./security_settings/Security_Settings";

const Settings = () => {
  const [key, setKey] = useState("Profile");

  return (
    <section className="Settings Performance">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Settings</p>

      <div className="inner_section_box">
        <div className="inner_box">
          <div className="inner_tab_content">
            <Tab.Container
              id="left-tabs-example"
              activeKey={key}
              onSelect={(key) => setKey(key)}
            >
              <div>
                <div className="col-12">
                  <Nav variant="pills" className=" " fill>
                    <div className="tabs_holder">
                      <Nav.Item>
                        <Nav.Link to={"/"} eventKey="Profile">
                          Profile
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          to={"/services-inner/2"}
                          eventKey="Security_Settings"
                        >
                          Security Settings
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </Nav>
                </div>
                <div>
                  <Tab.Content>
                    <Tab.Pane eventKey="Profile">
                      <Profile />
                    </Tab.Pane>

                    <Tab.Pane eventKey="Security_Settings">
                      <Security_Settings />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </div>
            </Tab.Container>
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Settings;
